import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import thalesLogo from '../../assets/logo/thales.png';
import damenLogo from '../../assets/logo/damen.png';
import navalLogo from '../../assets/logo/naval.png';

const PartnersSectionComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)');

    return (
        <Box sx={{ backgroundColor: '#f2f2f2' }}>
            <Grid container sx={{ textAlign: 'center', position: 'relative' }}>
                <Grid item xs={12} sm={12} sx={{ py: 2, mb: 5 }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 60, textAlign: 'center', color: '#08244d' }}>
                        Partners
                    </Typography >
                </Grid>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} sx={{ marginTop: 5, mb: isSmallScreen ? 1 : 20, alignSelf: 'center' }}>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        whileHover={{ scale: 1.1, rotate: 2 }}
                        animate={{
                            filter: ["drop-shadow(0 0 0px rgba(0,0,0,0))", "drop-shadow(0 0 10px rgba(79, 172, 254, 0.5))", "drop-shadow(0 0 0px rgba(0,0,0,0))"]
                        }}
                        transition={{
                            duration: 0.5,
                            delay: 0.1,
                            filter: {
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }
                        }}
                    >
                        <img src={thalesLogo} style={{ objectFit: 'cover', width: isSmallScreen ? 300 : 450 }} />
                    </motion.div>
                </Grid>
                <Grid item xs={12} sm={4} sx={{ marginTop: 5, mb: isSmallScreen ? 1 : 20, alignSelf: 'center' }}>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        whileHover={{ scale: 1.1, rotate: -2 }}
                        animate={{
                            filter: ["drop-shadow(0 0 0px rgba(0,0,0,0))", "drop-shadow(0 0 10px rgba(79, 172, 254, 0.5))", "drop-shadow(0 0 0px rgba(0,0,0,0))"]
                        }}
                        transition={{
                            duration: 0.5,
                            delay: 0.2,
                            filter: {
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: 1 // Offset the pulse
                            }
                        }}
                    >
                        <img src={damenLogo} style={{ objectFit: 'cover', width: isSmallScreen ? 250 : 350 }} />
                    </motion.div>
                </Grid>
                <Grid item xs={12} sm={2}></Grid>
            </Grid>
        </Box>
    );
}

export default PartnersSectionComponent;
